import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import axios from 'axios'
import VueAxios from 'vue-axios'

var VueCookie = require('vue-cookie');

Vue.use(VueCookie);
Vue.use(require('vue-jalali-moment'));
Vue.use(Vuetify);
Vue.use(VueAxios, axios)
export default new Vuetify({
    rtl: true,
});
